const DAY_ORDER = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const SUMMARY_ORDER = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const DAY_LABEL = {
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
};

function clockMinutes(value) {
  const [h, m] = String(value || '00:00').split(':').map(Number);
  if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
  return h * 60 + m;
}

function clockLabel(total) {
  const h = Math.floor(total / 60) % 24;
  const m = total % 60;
  const hour = h % 12 || 12;
  const suffix = h >= 12 ? 'pm' : 'am';
  return `${hour}:${String(m).padStart(2, '0')}${suffix}`;
}

function nextDay(day) {
  return DAY_ORDER[(DAY_ORDER.indexOf(day) + 1) % 7];
}

function scheduleSlotSummary(entry) {
  const days = SUMMARY_ORDER.filter((day) => Array.isArray(entry?.days) && entry.days.includes(day));
  if (days.length === 0) return 'Choose at least one day.';
  const startMin = clockMinutes(entry.start);
  const endMin = clockMinutes(entry.end);
  if (startMin === null || endMin === null) return 'Choose a start and end time.';
  if (startMin === endMin) return 'End time matches the start, so this slot stays closed.';
  const overnight = endMin < startMin;
  const menu = entry.menu === 'drinks'
    ? (overnight ? 'Drinks only stay open' : 'Drinks only are open')
    : (overnight ? 'Full menu stays open' : 'Full menu is open');
  const startLabel = clockLabel(startMin);
  const endLabel = clockLabel(endMin);
  const reminderOff = entry.closingReminder === false;
  if (!overnight) {
    const when = days.map((day) => DAY_LABEL[day]).join(', ');
    const reminder = reminderOff
      ? 'No closing reminder.'
      : `One closing reminder, 30 minutes before ${endLabel}.`;
    return `${menu} ${when}, ${startLabel} to ${endLabel} the same day. ${reminder}`;
  }
  const spans = days.map((day) => (
    `${DAY_LABEL[day]} ${startLabel} through ${DAY_LABEL[nextDay(day)]} ${endLabel}`
  ));
  const remindAt = clockLabel((endMin - 30 + 1440) % 1440);
  const remindDays = days.map((day) => DAY_LABEL[nextDay(day)]).join(' and ');
  const joined = spans.length === 1 ? spans[0] : `${spans.slice(0, -1).join(', ')}, and ${spans[spans.length - 1]}`;
  const reminder = reminderOff
    ? 'No closing reminder.'
    : `One closing reminder, at ${remindAt} ${remindDays}.`;
  return `${menu} ${joined}. ${reminder} No extra open message at midnight.`;
}

module.exports = { scheduleSlotSummary };
